"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../ui");
var _index = require("../index");
var _ticker = require("../../ticker");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var H6 = (0, _styledComponents.default)(_ui.H6)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 5px;\n"])));
var TertiaryShadeText = (0, _styledComponents.default)(_ui.Small)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var TransactionId = function TransactionId(_ref2) {
  var children = _ref2.children,
    splitPosition = _ref2.splitPosition;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransactionsTable'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex"
  }, t('id') + ':', /*#__PURE__*/_react.default.createElement(_index.TransactionsTruncate, {
    className: "ms-1",
    splitPosition: splitPosition
  }, children));
};
var Table = function Table(_ref3) {
  var transaction = _ref3.transaction,
    fiatWithdraw = _ref3.fiatWithdraw,
    splitPosition = _ref3.splitPosition;
  if (transaction.target) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(H6, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
      value: transaction.amount.value,
      ticker: transaction.ticker
    }), ' ', transaction.ticker), /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, /*#__PURE__*/_react.default.createElement(TransactionId, {
      splitPosition: splitPosition
    }, transaction.id)));
  }
  if (fiatWithdraw && transaction.betweenAccounts) {
    return /*#__PURE__*/_react.default.createElement(H6, null, /*#__PURE__*/_react.default.createElement(TransactionId, {
      splitPosition: splitPosition
    }, transaction.id));
  }
  if (fiatWithdraw) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(H6, null, transaction.to), /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, /*#__PURE__*/_react.default.createElement(TransactionId, {
      splitPosition: splitPosition
    }, transaction.id)));
  }
  if (transaction.hash && transaction.blockchain) {
    return /*#__PURE__*/_react.default.createElement(_index.TransactionsCryptoTooltip, {
      blockchain: transaction.blockchain,
      hash: transaction.hash
    }, /*#__PURE__*/_react.default.createElement(H6, null, /*#__PURE__*/_react.default.createElement(_index.TransactionsTruncate, {
      splitPosition: splitPosition
    }, transaction.hash)), /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, /*#__PURE__*/_react.default.createElement(TransactionId, {
      splitPosition: splitPosition
    }, transaction.id)));
  }
  if (transaction.blockchain) {
    return /*#__PURE__*/_react.default.createElement(_index.TransactionsCryptoTooltip, {
      blockchain: transaction.blockchain
    }, /*#__PURE__*/_react.default.createElement(H6, null, /*#__PURE__*/_react.default.createElement(TransactionId, {
      splitPosition: splitPosition
    }, transaction.id)));
  }
  if (transaction.invoiceId) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(H6, {
      className: "d-flex"
    }, /*#__PURE__*/_react.default.createElement(TransactionId, {
      splitPosition: splitPosition
    }, transaction.id)), /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, /*#__PURE__*/_react.default.createElement(TransactionId, {
      splitPosition: splitPosition
    }, transaction.id)));
  }
  return /*#__PURE__*/_react.default.createElement(H6, null, /*#__PURE__*/_react.default.createElement(TransactionId, {
    splitPosition: splitPosition
  }, transaction.id));
};
exports.Table = Table;